document.addEventListener("DOMContentLoaded", function () {
  let marqueeSliders = document.querySelectorAll(".floating-text-slider");

  marqueeSliders.forEach((marqueeSlider) => {
    let mainTicker = new Flickity(marqueeSlider, {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
      cellSelector: '.floating-text-with-icon-column',
      cellAlign: 'left',
      draggable: false
    });

    let speed = window.innerWidth <= 768 ? 0.5 : 1.2; 

    mainTicker.x = 0;
    let requestId;

    function play() {
      mainTicker.x -= speed;
      mainTicker.settle(mainTicker.x);
      requestId = window.requestAnimationFrame(play);
    }

    function pause() {
      if (requestId) {
        window.cancelAnimationFrame(requestId);
        requestId = undefined;
      }
    }

    marqueeSlider.addEventListener("mouseenter", () => pause());
    marqueeSlider.addEventListener("mouseleave", () => play());

    play();
  });
});
